
<div class="row-x">
  <div class="content column-x slides-container" [class.from-validation]="from == 'validation'">
    <app-slides class="app-slides"></app-slides>
  </div>
  <div class="content column-x login-container">
    <div class="centered-content">
      <div class="action-in-progress">
        <div *ngIf="isLoadingResults">
          <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <h1 class="form-name"><p class="bold">Welcome to Teradata Trial</p></h1>
      <div class="column-flow">
        <button mat-flat-button type="button" color="accent" class="login-btn oidc-login-btn"
          (click)="oidcSignIn()" [disabled]="isLoadingResults">Log in</button>

        <div class="tdu-action">
          <button type="button" class="oidc-link" (click)="tduSignIn()" [disabled]="isLoadingResults">Log in with TDU</button>
        </div>
      </div>
    </div>
  </div>
</div>
